@if (address) {
  <div>
    @if (showContact) {
      <div>
        @if (address?.contactInfo?.customerInfo?.firstName) {
          <strong
            class="pe-1"
            [innerHtml]="address?.contactInfo?.customerInfo?.firstName | highlight: highlight"
          ></strong>
        }
        @if (address?.contactInfo?.customerInfo?.lastName) {
          <strong
            [innerHtml]="address?.contactInfo?.customerInfo?.lastName | highlight: highlight"
          ></strong>
        }
      </div>
    }
    @if (address?.contactInfo.companyInfo?.name) {
      <div>
        <div [innerHtml]="address?.contactInfo.companyInfo?.name | highlight: highlight"></div>
      </div>
    }
    @if (address?.contactInfo.companyInfo?.name2) {
      <div>
        <div [innerHtml]="address?.contactInfo.companyInfo?.name2 | highlight: highlight"></div>
      </div>
    }
    @if (address?.address?.street) {
      <div>
        <div [innerHtml]="address?.address?.street | highlight: highlight"></div>
      </div>
    }
    @if (address?.address?.zip && address?.address?.city) {
      <div>
        <div>
          <span [innerHtml]="address?.address?.zip | highlight: highlight" class="pe-1"></span>
          <span [innerHtml]="address?.address?.city | highlight: highlight"></span>
        </div>
      </div>
    }
  </div>
}
